import { Injectable } from '@angular/core';
import { Employee } from '../models/employee.model';
import { BehaviorSubject } from 'rxjs';
import { AuthDetails } from '../models/auth-details.model';

@Injectable({
  providedIn: 'root'
})
export class LocalstorageService {
  requestedUrl: string;
  verifiedSubject: BehaviorSubject<boolean>;
  showConfirmDialog: boolean;

  constructor() {
    this.showConfirmDialog = true;
    this.verifiedSubject = new BehaviorSubject(false);
    if (this.isVerified())
      this.verifiedSubject.next(true);
  }

  isVerified(): boolean {
    let authDetails = this.getAuth();
    if (authDetails == undefined) return false;
    if (authDetails != undefined && authDetails.employeeInfo.corpId==null) return false;
    //if(authDetails.timestamp )

    return true;
  }

  isAuthenticated(): boolean {
    let authDetails = this.getAuth();
    if (authDetails == undefined) return false;
    if (authDetails.isAuthenticated == false) return false;

    return true;
  }

  getAuth(): AuthDetails {
    return JSON.parse(localStorage.getItem("auth"));
  }

  setAuth(auth: AuthDetails) {
    this.verifiedSubject.next(true);
    localStorage.setItem('auth', JSON.stringify(auth));
  }

  removeAuth() {
    this.verifiedSubject.next(false);
    localStorage.removeItem('auth');
  }

  getItem(key) {
    let value = null;
    let obj;
    value = localStorage.getItem(key);

    if (value !== null) {
      try {
        obj = JSON.parse(value);
      }
      catch (e) {
        // item is not json, just return it
        return value;
      }

      if (obj.hasOwnProperty('__expiry')) {
        let expiry = obj.__expiry;
        let now = Date.now();

        if (now >= expiry) {
          this.removeItem(key);
          return null;
        } else {
          // Return the data object only.
          return obj.__data;
        }
      } else {
        // Value doesn't have ttl data, just return it.
        return obj;
      }
    }
    else {
      console.log(key + ' not found');
    }
    return null;
  }

  setItem(key: string, value: any, ttl?: number) {
    // ttl is time to live in seconds
    // 43200 = 12 hours
    
    if (ttl) {
      let obj = {
        __data: value,
        __expiry: Date.now() + (ttl * 1000)
      };
      console.log('setting expiration on ' + key, obj);
      try {
        localStorage.setItem(key, JSON.stringify(obj));
        return true;
      } catch (e) {
        console.error('Unable to store ' + key + ' in localStorage due to ' + e.name);
        return false;
      }
    } else {
      localStorage.setItem(key, value);
    }
  }
  removeItem(key) {
    localStorage.removeItem(key);
  }
  clear() {
    localStorage.clear();
  }

}
